export const debtIndexNames: Record<string, string> = {
  "^ESTR": "ESTR",
  "^SOFR": "SOFR",
  "^SONIA": "SONIA",
  "^EURIBOR1M": "EURIBOR 1M",
  "^200010": "200010",
  "^120010": "120010",
  "^CPI": "linkage.consumerPriceIndex",
  PRIME_RATE: "linkage.primeRate"
};

// Hard coded - same constant in the backend
export const DEBT_MEASURE_ROLES = {
  principal: "1",
  interest: "2",
  pikInterest: "3",
  principalPrepayment: "4",
  principalRefinance: "5",
  vat: "6",
  callProtectionFee: "7",
  fixedFee: "8",
  yieldMaintenanceFee: "9",
  creditFacilityFee: "10",
  disbursement: "11",
  arrears: "12"
};

export const DEBT_MEASURE_FETCHABLE_NAME = "debt-measures";

export enum PaymentStatus {
  RESOLVED = "resolved",
  MISMATCH = "mismatch"
}